<mat-tab-group class="plan-listing-tab-group">
  <ng-container>
    <mat-tab label="Tab 1" tabindex="0" class="active-plan-tab">
      <ng-template mat-tab-label >{{'activePlansText'|translate:translations}}</ng-template>
      <div class="mb-10"></div>
      <!-- <div style="width: 100%;" > -->
      <span [hidden]="activePlans.length > 0">
        {{'noPlansText'|translate:translations}} <a href="/participants/plans/add-plan"> {{'creatingAPlanText'|translate:translations}}</a>.
      </span>
      @for (item of activePlans; track item) {
        <div
          class="plan-list-main-container {{item.planClassName}}"
          [hidden]="activePlans.length == 0"
          role="button"
          tabindex="0"
          (click)="navigate('participants/plans/view-plan/' + item.id)"
          (keydown.enter)="navigate('participants/plans/view-plan/' + item.id)"
          (keydown.space)="$event.preventDefault(); navigate('participants/plans/view-plan/' + item.id)">
          <div class="plan-list-heading">
            <span>
              <span class="plan-list-title">{{item.planName}}</span>
              <img src="assets/reminder-bell.svg" class="reminder-bell" [hidden]="!item.showReminderIcon">
            </span>
            <span class="plan-list-date">{{item.planSpecificDate}}</span>
          </div>
          <div class="plan-action-buttons" (click)="$event.stopPropagation()">
            <span matTooltip="{{'endThisPlanTooltipText'|translate:translations}}" class="mattooltip"  [matTooltipClass]="participantClassByRole" matTooltipPosition="above">
              <img src="assets/tick-plan-listing.svg" class="plan-list-action-button tick" (click)="navigate('participants/plans/close-plan/'+item.id)">
            </span>
            <span matTooltip="{{'editPlanText'|translate:translations}}" class="mattooltip"  [matTooltipClass]="participantClassByRole" matTooltipPosition="above">
              <img src="assets/editpen.svg" class="plan-list-action-button pen" (click)="navigate('participants/plans/edit-plan/'+item.id)">
            </span>
          </div>
        </div>
      }

    <!-- </div> -->
  </mat-tab>
</ng-container>

<ng-container>
  <mat-tab label="Tab 2" tabindex="1" >
    <ng-template mat-tab-label>{{'completedPlansText'|translate:translations}}</ng-template>
    <div class="mb-10"></div>
    @for (item of completedPlans; track item) {
      <div
        class="plan-list-main-container completed-plans"
        role="button"
        tabindex="0"
        (click)="navigate('participants/plans/view-close-plan/' + item.id)"
        (keydown.enter)="navigate('participants/plans/view-close-plan/' + item.id)"
        (keydown.space)="$event.preventDefault(); navigate('participants/plans/view-close-plan/' + item.id)">
        <div class="plan-list-heading">
          <span>
            <span class="plan-list-title">{{item.planName}}</span>
            <img src="assets/reminder-bell.svg" class="reminder-bell" [hidden]="!item.showReminderIcon">
          </span>
          <span class="plan-list-date">{{item.planSpecificDate}}</span>
        </div>
      </div>
    }
  </mat-tab>
</ng-container>


</mat-tab-group>

